import React from 'react';
import Page from "../../components/Page";
import {useState} from "react";
import useInputs from "../../hooks/useInputs";
import GenericInputLayout from "../../layouts/GenericInput/GenericInputLayout";
import ItemUtils from "../../utils/ItemUtils";
import {useSnackbar} from "notistack";
import {DayOfWeekInputs} from "./DayOfWeekInputs";
import {CreateDayOfWeek, DeleteDayOfWeek, GetDaysOfWeek, UpdateDayOfWeek} from "../../api/DayOfWeekApi";

export default function DayOfWeekPage() {
  const [items, setItems] = useState([]);
  const inputs = useInputs(DayOfWeekInputs);
  const {enqueueSnackbar} = useSnackbar();

  const populate = () => {
    GetDaysOfWeek().then(json => {
      setItems(json);
    })
  }

  React.useEffect(() => {
    populate()
  }, []);

  const handleDelete = async (e, item) => {

    return DeleteDayOfWeek(item.id).then(() => {
      setItems(ItemUtils.removeItem(items, item));
      enqueueSnackbar(`Successfully deleted material type: ${item.name}`, {variant: 'success'});
    });
  }

  const handleEdit = async (values) => {

    return UpdateDayOfWeek(values.id, values).then(json => {
      setItems(ItemUtils.replaceItem(items, json));
    });
  }

  return (
      <Page title="Day of Week" sx={{ position: 'relative'}}>
        <GenericInputLayout
            header="Day of Week"
            newHeader="Add Day of Week"
            inputs={inputs}
            items={items}
            filterBy={'name'}
            createAction={CreateDayOfWeek}
            onCreate={populate}
            onEdit={handleEdit}
            onDelete={handleDelete}
            getDisplayName={item => item.name}
        />
      </Page>
  )
}